import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameServices } from '../../services/game-services';
import { Cell } from 'src/games/phaserblocks/logic/grid/cell';
import { BehaviorSubject } from 'rxjs';
import { BlocksAssetType } from '../../model/blocks-types';

export class CellViewModel {
  public get id() {
    return this.cell.id;
  }
  public get row() {
    return this.cell.row;
  }
  public get column() {
    return this.cell.column;
  }
  public get cellColor() {
    return 0xffffff;
  }

  public get cellAlpha() {
    const rowStripe = this.row < 3 || this.row > 5;
    const colStripe = this.column < 3 || this.column > 5;
    return (rowStripe && colStripe) || (!rowStripe && !colStripe) ? 0.05 : 0.1;
  }
  public get blockNormalAsset() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.BlockNormal);
  }
  public get blockNormalHighlightAsset() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.BlockNormalHighlight);
  }
  public get blockMultiplierAsset() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.BlockMultiplier);
  }
  public get blockMultiplierHighlightAsset() {
    return this.gameServices.assetCatalogueService.getAsset(
      BlocksAssetType.BlockMultiplierHighlight,
    );
  }
  public get onGameSetupCompleteTrigger() {
    return this.gameServices.gameRunnerService.onGameSetupCompleteTrigger;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get isHighlighted$() {
    return this.isHighlighted.asObservable();
  }
  public get isBlockHighlighted$() {
    return this.isBlockHighlighted.asObservable();
  }
  public get showProjection$() {
    return this.showProjection.asObservable();
  }
  public get canDrop() {
    return this.cell.currentBlock === null;
  }
  public get blockData$() {
    return this.cell.blockData$;
  }
  public get points$() {
    return this.cell.points$;
  }

  private isHighlighted = new BehaviorSubject<boolean>(false);
  private isBlockHighlighted = new BehaviorSubject<boolean>(false);
  private showProjection = new BehaviorSubject<boolean>(false);

  constructor(
    private gameServices: GameServices,
    private cell: Cell,
  ) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public highlightCell(highlight: boolean) {
    this.isHighlighted.next(highlight);
  }

  public highlightCellBlocks(highlight: boolean) {
    this.isBlockHighlighted.next(highlight);
  }

  public projectCell(show: boolean) {
    this.showProjection.next(show);
  }
}
